const baseUrl = 'api';

export const Apis = {
  user: {
    post_login: baseUrl + '/login',
    post_logout: baseUrl + '/logout',
    post_register: baseUrl + '/register',
    get_user_info: baseUrl + '/user/who_am_i',
    post_updateUserAvatar: baseUrl + '/user/update_avatar',
    put_updateUser: baseUrl + '/user/update_user',
    post_findUserByNameOrPhone: baseUrl + '/user/find_user_by_name_or_phone',
    get_findMessageByTargetUser: baseUrl + '/message/my_all',
    put_updateMessageRead: baseUrl + '/message/read',
    put_batchUpdateMessageRead: baseUrl + '/message/batch_read',
    put_readAllMessage: baseUrl + '/message/read_all',
    get_findUnreadMessageByTargetUser: baseUrl + '/message/my_unread',
    get_getSystemAvatarList: baseUrl + '/user/system_avatar',
    get_getSystemBannerList: baseUrl + '/user/system_banner',
    post_updateUserAvatar2: baseUrl + '/user/update_avatar_2',
    post_weixinAuthLogin: baseUrl + '/weixin_login',
    get_getMySubAccount: baseUrl + '/sub_account/my',
    get_getMyPrimaryAccount: baseUrl + '/sub_account/primary',
    put_deleteSubAccount: baseUrl + '/sub_account/delete_sub_account',
    put_deletePrimaryAccount: baseUrl + '/sub_account/delete_primary_account',
    post_addSubAccount: baseUrl + '/sub_account/add',
    get_findMyAddress: baseUrl + '/user/address',
    post_updateDefaultAddress: baseUrl + '/user/address/update_default',
    put_deleteAddress: baseUrl + '/user/address/delete',
    put_updateAddress: baseUrl + '/user/address',
    post_addAddress: baseUrl + '/user/address',
    put_deleteMerchantUserRelationship: baseUrl + '/user/merchant_user_relationship',
    get_findMyMerchantUser: baseUrl + '/user/merchant_user_relationship/my_user',
    get_findMyMerchant: baseUrl + '/user/merchant_user_relationship/my_merchant',
    put_updateMerchantUserRelationshipStatus: baseUrl + '/user/merchant_user_relationship/update_status',
    post_addMerchantUserRelationship: baseUrl + '/user/merchant_user_relationship',
    get_getMyMerchant: baseUrl + '/user/my_merchant',
    post_updateMerchantAvatar: baseUrl + '/user/update_merchant_avatar',
    post_updateMerchantAvatar2: baseUrl + '/user/update_merchant_avatar_2',
    post_updateMerchantImage: baseUrl + '/user/update_merchant_image',
    post_updateMerchantImage2: baseUrl + '/user/update_merchant_image_2',
    put_updateMerchant: baseUrl + '/user/update_merchant'
  },
  order: {
    get_findLatest30MerchantOrder: baseUrl + '/order/latest_30_merchant',
    get_findLatest30MerchantOrderStat: baseUrl + '/order/latest_30_merchant_stat',
    get_findTopNNotHandleOrder: baseUrl + '/order/top_n_not_handle/:count',
    get_findMerchantOrder: baseUrl + '/order/merchant',
    post_updateOrderProductSkuStatus: baseUrl + '/order/update_sku_status',
    post_batchUpdateOrderProductSkuStatus: baseUrl + '/order/batch_update_sku_status'
  },
  product: {
    post_readBarcode: baseUrl + '/product/image_barcode',
    post_saveProduct: baseUrl + '/product/add_with_image',
    get_findProductByBarcode: baseUrl + '/product/find_by_barcode/:barcode',
    get_findProductByProductCode: baseUrl + '/product/find_by_product_code/:productCode',
    get_findProductByProductName: baseUrl + '/product/find_by_product_name/:productName',
    get_findImageByBarcode: baseUrl + '/image/find_by_barcode/:barcode',
    get_findDemandProductByBarcode: baseUrl + '/product/find_demand_product_by_barcode/:barcode',
    get_findDemandProductByProductCode: baseUrl + '/product/find_demand_product_by_product_code/:productCode',
    get_findDemandProductByProductName: baseUrl + '/product/find_demand_product_by_product_name/:productName',
    get_findProductBySystem: baseUrl + '/product/find_by_system',
    post_saveProduct2: baseUrl + '/product/batch_add',
    post_batchAddProduct2: baseUrl + '/product/batch_add2',
    post_addProduct: baseUrl + '/product_2',
    put_updateProductImage: baseUrl + '/product/update_image',
    put_updateProduct: baseUrl + '/product',
    put_updateProductWithImage: baseUrl + '/product/update_with_image',
    put_deleteSystemProduct: baseUrl + '/product/delete',
    get_getCategory: baseUrl + '/product/category',
    post_findSupplyProduct: baseUrl + '/product/supply',
    post_findSupplyProductCount: baseUrl + '/product/supply/count',
    post_findSystemProduct: baseUrl + '/product/system',
    post_findSystemProductCount: baseUrl + '/product/system/count',
    post_findMyProduct: baseUrl + '/product/my',
    post_findMyProductCount: baseUrl + '/product/my/count',
    post_findMyAllProduct: baseUrl + '/product/my_all',
    post_uploadImage: baseUrl + '/product/upload_image',
    post_deleteUserProducts: baseUrl + '/product/delete_user_products',
    post_parsePdf: baseUrl + '/product/parse_pdf',
    get_getAllProductSpec: baseUrl + '/product/product_spec',
    get_getSpecByProduct : baseUrl + '/product/product_spec/:productId',
    post_updateProductSku: baseUrl + '/product_sku',
    post_findTopNOrderProduct: baseUrl + '/product/top_n_order/:count',
    get_getMyProductUnit: baseUrl + '/product_unit/my',
    put_batchUpdateProduct: baseUrl + '/product/batch_update',
    post_addProductUnit: baseUrl + '/product_unit',
    post_mergeProduct: baseUrl + '/product/merge'
  },
  productTag: {
    get_getMyMerchantProductTag: baseUrl + '/product_tag/my',
    post_addMerchantProductTag: baseUrl + '/product_tag/add',
    post_batchAddMerchantProductTag: baseUrl + '/product_tag/batch_add',
    put_batchUpdateMerchantProductTagSort: baseUrl + '/product_tag/batch_update_tag',
    post_deleteMerchantProductTag: baseUrl + '/product_tag/delete_tag',
    post_batchDeleteMerchantProductTag: baseUrl + '/product_tag/batch_delete_tag',
    put_updateMerchantProductTagName: baseUrl + '/product_tag/update_tag',
    post_addProductTag: baseUrl + '/product_tag/add_product_tag',
    get_getMerchantProductTagByProduct: baseUrl + '/product_tag/get_by_product/:productId'
  },
  orderNotify: {
    post_addNotifyList: baseUrl + '/add_order_notify_list',
    get_getMyOrderNotify: baseUrl + '/my_order_notify',
    put_updateInvoiceToDone: baseUrl + '/invoice/update_to_done'
  },
  weixin: {
    post_getWeixinJsapiSignature: baseUrl + '/weixin_jsapi_signature',
    get_getPcOpenSdkTicket: baseUrl + '/weixin_pc_open_sdk_ticket'
  }
}
